import { useCoursesLoaderData } from "./coursesLoader.ts";

export default function useProgramDecision() {
  const { currentTerm } = useCoursesLoaderData();
  return currentTerm?.programDecision;
}
